import client from '../client';

export interface OrderSearchFilter {
  IsShippedMode: boolean;
  CustomerId?: string | null;
  CustomerPo?: string;
  ItemState?: number;
  InvoiceNumber?: number;
  ShipToName?: string;
  ShipToAddress?: string;
  OrderBy?: string;
  Page?: number;
  PageSize?: number;
  ShippedDateFrom?: string;
  ShippedDateTo?: string;
}

export interface OrderSearchResult {
  OrderId: number;
  OrderDate: string;
  EstShipDate: string;
  CustomerId: number;
  CustomerName: string;
  ShipToName: string;
  CustomerOrderNo: string;
  ShipVia: string;
  DropShip: boolean;
  ItemCount: number;
  Total: number;
  Age: number;
  DaysFromShip: number;
  Items: Array<{
    PartNumber: string;
    Status: string;
  }>;
}

export interface OrderSearchResponse {
  count: number;
  result: OrderSearchResult[];
  atCutterCount: number;
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface FilterOptions {
  customers: Array<{ CustomerId: string; CustomerName: string }>;
  shipMethods: string[];
  itemStates: Array<{ ActionId: number; ActionName: string }>;
}

export const orderService = {
  /**
   * Search orders with filters
   */
  searchOrders: async (filter: OrderSearchFilter): Promise<OrderSearchResponse> => {
    const response = await client.post('/orders/search', filter);
    return response.data;
  },

  /**
   * Get order detail by ID
   */
  getOrderDetail: async (orderId: number): Promise<any> => {
    const response = await client.get(`/orders/${orderId}`);
    return response.data;
  },

  /**
   * Get action history for an order
   */
  getActionHistory: async (orderId: number): Promise<any> => {
    const response = await client.get(`/orders/${orderId}/history`);
    return response.data;
  },

  /**
   * Get filter options for open orders
   */
  getFilterOptions: async (): Promise<FilterOptions> => {
    const response = await client.get('/orders/filter-options');
    return response.data;
  },

  /**
   * Update shipping method for an order
   */
  updateShippingMethod: async (orderId: number, shipVia: string): Promise<void> => {
    await client.put(`/orders/${orderId}/shipping-method`, { shipVia });
  },

  /**
   * Update Ship To address for an order
   */
  updateShipTo: async (orderId: number, data: {
    ShipToName: string;
    ShipToAddress1: string;
    ShipToAddress2: string;
    ShipToCity: string;
    ShipToState: string;
    ShipToZipCode: string;
    ShipToCountry: string;
  }): Promise<void> => {
    await client.put(`/orders/${orderId}/ship-to`, data);
  },

  /**
   * Cancel an order
   */
  cancelOrder: async (orderId: number, canceledBy: string): Promise<void> => {
    await client.post(`/orders/${orderId}/cancel`, { canceledBy });
  },

  /**
   * Re-instate a canceled order
   */
  reinstateOrder: async (orderId: number): Promise<void> => {
    await client.post(`/orders/${orderId}/reinstate`);
  }
};
